export function showAdminView() {
  const user = useState('user');

  if (user.value && user.value.subscription === 'admin') {
    const useNonAdminView = useCookie('useNonAdminView');
    if (useNonAdminView.value) {
      return false;
    }
    else {
      return true;
    }
  }
  else {
    return false;
  }
}